import React from 'react';
import TestimonialsItem from './TestimonialsItem';
import {PageBanner} from "../../../common/elements";
import uuid from './../../../../helpers/uuid';
import ThemePageBanner from '../../../dashboardNew/components/ThemePageBanner';
//type 0 is "Network member"
// type1 is company

const testimonialsData = [
    {
        name: "Andrea Benneyworth",
        type: 0,
        body: 'The platform is great, user-friendly and informative and gives me a lot of info to absorb at my pace. The package I have takes the hard work out of linking my profiles and updating my brand into a cohesive data set. I look professional even when not feeling it! And finally, the team have been awesome. Friendly, know their stuff and do what they say they are going to do. I recommend. If you are thinking of creating a NED portfolio, this is money well spent.'
    },
    {
        name: "Iain Burns",
        type: 0,
        body: "I feel very supported from all directions. There is a wealth of resources to draw on to learn from as well as capability to reach out to the Network. The jobs board and comprehensive search facilities are very good along with the ability to tune my preferences."
    },
    {
        name: "Peter",
        type: 0,
        body: "I enjoyed a really good coaching session with Rob. He offered an excellent and well-structured session offering advice on all the key considerations as to how to self-reflect, position one’s own skills and how to develop a brand. In all, excellent advice based upon his very clear experience and relevant up to date perspectives as to how Companies, Boards and executives would think and consider entertaining applications and approaches for roles with corporates. The session I enjoyed was very personal and appreciative of my own background, experience and desires. In all, a very professional and positive exercise which has given me a lot of extremely useful tips. Thank you very much indeed."
    },
    {
        name: "Stephen Voice",
        type: 0,
        body: "I have recently had a session with Executive Coach, Barbara Dewast, provided by In Touch. I can honestly say that Barbara was brilliant and has given me some new ideas as well as the inspiration to go forward with my new career. The administration provided by In Touch was of the highest quality too."
    },
    {
        name: "Paul Le Claire",
        type: 0,
        body: "I was very impressed with the team's professionalism and grasp of how to get me back on track. You showed initiative, patience and skill."
    },
    {
        name: "Barbara",
        type: 0,
        body: "The whole team at In Touch Networks have been really simple and easy to work with. Their customer support and CV/LinkedIn writing services have made promoting my diverse skills, simple and easy. Thank you."
    },
    {
        name: "Collette Stone",
        type: 0,
        body: "A partnership approach where the cv owner and the cv writer together find the right words and format. Adam took the time to understand my NED offer first, to find and bring out the elements that are going to be most relevant, and then created a strapline that summarised the whole in a way I hadn’t thought of before. A valuable process in its own right."
    },
    {
        name: "Susan Hollins",
        type: 0,
        body: "I'm impressed with the high professionalism which staff of In Touch approach their engagement with their clients, and with the high quality and increasing variety of on-demand videos, recordings of webinars, and other highly relevant training, development and generally informative resources, alongside job opportunities, all of which are readily available to members. I've just completed the 7 week Webinar Development Programme for aspiring non-executive directors and greatly enjoyed working with colleagues from very diverse business backgrounds. The facilitators were super in their encouragement and challenge to all of us while providing high-quality material to push us on in our endeavors."
    },
    {
        name: "JM",
        type: 0,
        body: "Ahead of the Curve - I started this course, not really knowing what I was going to get from it. However, the content is huge and the biggest takeaway is the assurance that I can now develop and execute an action plan for the way forward. An absolutely inspiring course! I would recommend this as essential for anyone wishing to become a non-executive director."
    },
    {
        name: "Fiona Berry Gray",
        type: 0,
        body: "Very impressed with In Touch. The organisation is adding more and more for members with useful webinars, podcasts and general information on a very user-friendly website. I recently completed the Confident Woman Director Interactive Webinar. The CWD experience was really very good, in that, it was structured well with informative content and useful homework. The facciltators were excellent, taking us all on an empowering journey. One of the most unexpectedly rewarding aspects was with regards to the other women, on the course, who were both experienced and professional - supporting each other through the duration, and who have continued to stay in touch. CWD is an extremely useful webinar series for any woman looking to use her experience to make a positive impact."
    }
]


class TestimonialsPage extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div>
                <article className="testimonials-body">
                    <div className="constainer-fluid margin-bottom">
                        <div className="text-center">
                            <ThemePageBanner image='/images/testimonials-header.jpg' heading='Testimonials'/>
                        </div>
                    </div>
                    <div className="container theme-page-content-wrapper">
                        <div className="row">
                            <div className="col-12 heading-section no-margin">
                                <p className='body-copy'>
                                    We've helped thousands of our members
                                    secure fantastic roles, develop their
                                    professional skills and successfully
                                    transition their careers. But don't just take our word for it -
                                    here's what they say about our services.
                                </p>
                            </div>
                            <div className="col-xs-12 testimonials-list">
                                {testimonialsData.map((testimonial) => (
                                    <TestimonialsItem
                                        key={uuid()}
                                        data={testimonial}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        );
    }
}

export default TestimonialsPage;


// WEBPACK FOOTER //
// src/client/components/site/features/testimonials/TestimonialsPage.js